import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import { useIsMobile, getResponsiveImageUrl } from 'helpers/ui';
import { FallbackImage } from '@rcw/ui';
import '../downloadRcm.scss';

export function DownloadHero({ data }) {
  const isMobile = useIsMobile(600);

  return (
    <div className='heroContainer'>
      <div className='downloadImgContainer'>
        <FallbackImage
          src={getResponsiveImageUrl(
            data.imageUrl,
            data.mobileImageUrl,
            isMobile,
          )}
          fallbackSrc={data.imageUrl}
          alt='Roland Cloud Manager'
        />
      </div>

      <div
        className='heroContainer_data'
        style={{ textAlign: 'left', alignItems: 'flex-start' }}
      >
        <div
          className='heroContainer_title proxima-nova-bold'
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.title) }}
        />
        <div
          className='heroContainer_body'
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.body) }}
        />
      </div>
    </div>
  );
}

DownloadHero.propTypes = {
  data: PropTypes.shape({
    imageUrl: PropTypes.string.isRequired,
    mobileImageUrl: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
  }).isRequired,
};
